module.exports = __webpack_public_path__ + "img/proList2_27_15.4423dde7.jpg";